import { useSortBy } from "react-instantsearch-hooks";
import { SortByItem } from "instantsearch.js/es/connectors/sort-by/connectSortBy";

import ComboBox from "./ComboBox";
import { StyleProp, ViewStyle } from "react-native";

const SortBy: React.FC<{ items: SortByItem[]; onChange?: (refinement: string) => void; style?: StyleProp<ViewStyle> }> =
  ({ items, onChange, style }) => {
    const { options, refine, currentRefinement } = useSortBy({ items });
    return (
      <ComboBox
        style={style}
        value={currentRefinement}
        myOptions={options.map(({ value, label }) => ({ myValue: value, myLabel: label }))}
        myPlaceholder={"Sort by..."}
        onSelect={({ myValue }) => {
          refine(myValue);
          onChange?.(myValue);
        }}
      />
    );
  };

export default SortBy;
